import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { BoxForm, CodeField, Select, Switch } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { useGetCounterStyles } from '../../hooks/useGetCounterStyles'
import { KNOWLEDGE_BASE_URL } from './constants'

import type { Schema } from './schema'

export const AppearanceSection = (): React.JSX.Element => {
  const ability = useAbility()
  const { t: tc } = useTranslation('common')
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.multiAnchor.appearance',
  })

  const { control } = useFormContext<Schema>()

  const counterStyles = useGetCounterStyles()

  const cannotUpdate: boolean = ability.cannot(
    'update',
    'GlobalSetupFeature-defaults-richPlacements',
  )

  return (
    <Paper data-cy='section-appearance'>
      <SectionHeader
        subtitle={t('subtitle')}
        title={t('title')}
      />

      <GapBox />

      <BoxForm>
        <Select
          control={control}
          disabled={cannotUpdate}
          label={t('counterStyle.label')}
          name='counterStyle'
          options={counterStyles}
          tooltip={{ content: t('counterStyle.tooltip') }}
        />

        <Switch
          control={control}
          disabled={cannotUpdate}
          label={t('showCloseButton.label')}
          labelPlacement='start'
          name='showCloseButton'
          tooltip={{ content: t('showCloseButton.tooltip') }}
        />
        <Switch
          control={control}
          disabled={cannotUpdate}
          label={t('fullWidthMode.label')}
          labelPlacement='start'
          name='fullWidthMode'
          tooltip={{ content: t('fullWidthMode.tooltip') }}
        />
        <CodeField
          control={control}
          disabled={cannotUpdate}
          language='json'
          name='customStyling'
          title={t('customStyling.label')}
          tooltip={{
            content: t('customStyling.tooltip'),
            link: {
              title: tc('learnMore'),
              url: KNOWLEDGE_BASE_URL.CUSTOM_STYLING,
            },
          }}
        />
      </BoxForm>
    </Paper>
  )
}
